import React from 'react';
import ReactDom from 'react-dom';
import {connect, Provider} from 'react-redux'
import {createStore, combineReducers} from 'redux';
import {LoadingIndicatorSvg} from '../icons';

const reducer = (state = false, {type, isLoading}) => {
    if (type === 'SET_LOADING') return isLoading;
    return state;
};
const store = createStore(combineReducers({isLoading: reducer}));
const setLoading = isLoading => {
    store.dispatch({type: 'SET_LOADING', isLoading});
    const classList = document.getElementById('loader-app').classList
    if (isLoading) {
        classList.remove('d-none')
        classList.add('d-flex')
    } else {
        classList.remove('d-flex')
        classList.add('d-none')
    }
}

const Loading = ({isLoading}) => {
    return <div id="loader-app" className={isLoading ? 'd-flex' : 'd-none'}>
        <LoadingIndicatorSvg width='100' height='100'/>
    </div>
}

const Wrapped = connect(state => state)(Loading);

ReactDom.render(<Provider store={store}><Wrapped/></Provider>, document.getElementById('loading-container'));

export default setLoading;